// extracted by mini-css-extract-plugin
module.exports = {"lightboxImage":"Review_lightboxImage__ntUY9","leadingReview":"Review_leadingReview__fQRFh"};